import { Button } from '@mui/material';
import React from 'react';
import styles from './RaisedButton.css';

function RaisedButton({ label, primary, icon, children, ...props }) {
  return (
    <Button variant="contained" color={primary ? 'primary' : 'secondary'} {...props}>
      {icon ? <div className={styles.leftIcon}>{icon}</div> : null}
      {label}
      {children}
    </Button>
  );
}

export default RaisedButton;
